const pendingBySetter = new WeakMap();

export function startLoading(setLoading) {
   if (!setLoading) return () => {};
   const count = pendingBySetter.get(setLoading) || 0;
   pendingBySetter.set(setLoading, count + 1);
   if (count === 0) setLoading(true);
   return () => {
      const remaining = (pendingBySetter.get(setLoading) || 1) - 1;
      if (remaining > 0) pendingBySetter.set(setLoading, remaining);
      else {
         pendingBySetter.delete(setLoading);
         setLoading(false);
      }
   };
}
